module.exports = __webpack_public_path__ + "assets/img/202109-2.bcf0434a.png";